import Modals from '../../types/enums/modals';
import { IModalState } from '../../types/interfaces/states';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';

/**
 * Initial state for the modal slice.
 * Contains the current active modal and its parameters.
 */
const initialState = {
  current: null,
  params: {},
} as IModalState;

/**
 * Redux slice for managing modal state.
 * Handles opening, closing, and parameter management for application modals.
 */
const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    /**
     * Clears the current modal and resets all modal parameters.
     */
    clearModal: (state) => {
      state.current = null;
      state.params = {};
    },
    /**
     * Sets the current active modal.
     *
     * @param {PayloadAction<Modals>} action - The modal type to display
     */
    setModal: (state, action: PayloadAction<Modals>) => {
      state.current = action.payload;
    },
    /**
     * Sets or updates parameters for the current modal.
     *
     * @param {PayloadAction<{ [key: string]: unknown }>} action - Object containing modal parameters
     */
    setModalParams: (
      state,
      action: PayloadAction<{ [key: string]: unknown }>
    ) => {
      state.params = action.payload;
    },
  },
});

const { actions, reducer: modalReducer } = modalSlice;
export const { clearModal, setModal, setModalParams } = actions;
export const modalSelector = (state: RootState) => state.modal;
export default modalReducer;
